import React, { useState } from "react";
import styles from "./mobile-perms-btn.module.scss";
import type { GrantedPermission } from "@/types/modular-permissions.types";
import { PERMISSION_MOD_SELECT_ALL_ID } from "@/constants/mod-perms-tool.constants";
import BlessModal from "@/components/layout/modal/bless-modal";
import { CgClose } from "react-icons/cg";
import PermList from "@/features/mod-perms/components/cards/permissions-card/perm-list/perm-list";

type Props = {
  delegate: GrantedPermission;
};

const MobilePermsBtn = ({ delegate }: Props) => {
  const [permsListOpen, setPermsListOpen] = useState(false);

  return (
    <>
      <button
        className={styles.mobilePermsBtn}
        onClick={() => setPermsListOpen(true)}
      >
        Edit
      </button>
      <BlessModal
        open={permsListOpen}
        closeIcon={<CgClose size={18} />}
        onCancel={() => setPermsListOpen(false)}
        classNames={{
          content: styles.modal,
        }}
      >
        <PermList delegate={delegate} />
      </BlessModal>
    </>
  );
};

export default MobilePermsBtn;
